/**
 * Ids fixos de `trait_code`. Ficam FORA da spec (o hash nao muda), pelo mesmo
 * motivo do PROTOCOL_V1_ID: o tablet grava `measurement.trait_code_id` offline e
 * nunca recebe a tabela `trait_code` pelo sync. O seed insere cada codigo com o
 * id daqui.
 *
 * `trait_code` e imutavel entre versoes do protocolo: um codigo novo ganha a
 * proxima linha, e nenhum id daqui muda depois de haver dado coletado.
 */
export const TRAIT_CODE_IDS: Readonly<Record<string, string>> = {
  A_CER:         '01926a4c-0000-7000-8000-00000000b001',
  A_GAR:         '01926a4c-0000-7000-8000-00000000b002',
  A_BPE:         '01926a4c-0000-7000-8000-00000000b003',
  P_TOR:         '01926a4c-0000-7000-8000-00000000b004',
  A_SUB:         '01926a4c-0000-7000-8000-00000000b005',
  C_CAB:         '01926a4c-0000-7000-8000-00000000b006',
  C_FRO:         '01926a4c-0000-7000-8000-00000000b007',
  C_PES:         '01926a4c-0000-7000-8000-00000000b008',
  C_ESP:         '01926a4c-0000-7000-8000-00000000b009',
  C_BRA:         '01926a4c-0000-7000-8000-00000000b010',
  C_ANT:         '01926a4c-0000-7000-8000-00000000b011',
  C_CANA:        '01926a4c-0000-7000-8000-00000000b012',
  C_DOR:         '01926a4c-0000-7000-8000-00000000b013',
  C_LOM:         '01926a4c-0000-7000-8000-00000000b014',
  C_GAR:         '01926a4c-0000-7000-8000-00000000b015',
  C_FEM:         '01926a4c-0000-7000-8000-00000000b016',
  C_TIB:         '01926a4c-0000-7000-8000-00000000b017',
  C_CANP:        '01926a4c-0000-7000-8000-00000000b018',
  C_COR:         '01926a4c-0000-7000-8000-00000000b019',
  L_OLH:         '01926a4c-0000-7000-8000-00000000b020',
  L_CAB:         '01926a4c-0000-7000-8000-00000000b021',
  L_PEI:         '01926a4c-0000-7000-8000-00000000b022',
  L_ANC:         '01926a4c-0000-7000-8000-00000000b023',
  L_ISQ:         '01926a4c-0000-7000-8000-00000000b024',
  PE_CAN:        '01926a4c-0000-7000-8000-00000000b025',
  PE_CAR:        '01926a4c-0000-7000-8000-00000000b026',
  PE_ANT:        '01926a4c-0000-7000-8000-00000000b027',
  PE_TOR:        '01926a4c-0000-7000-8000-00000000b028',
  PE_ABD:        '01926a4c-0000-7000-8000-00000000b029',
  AN_ESU:        '01926a4c-0000-7000-8000-00000000b030',
  AN_COX:        '01926a4c-0000-7000-8000-00000000b031',
  AN_IESP:       '01926a4c-0000-7000-8000-00000000b032',
  AN_IGAR:       '01926a4c-0000-7000-8000-00000000b033',
  AN_UMR:        '01926a4c-0000-7000-8000-00000000b034',
  AN_FTI:        '01926a4c-0000-7000-8000-00000000b035',
  AN_JAR:        '01926a4c-0000-7000-8000-00000000b036',
  AN_QTA:        '01926a4c-0000-7000-8000-00000000b037',
  AN_QTP:        '01926a4c-0000-7000-8000-00000000b038',
  AN_CASA:       '01926a4c-0000-7000-8000-00000000b039',
  AN_CASP:       '01926a4c-0000-7000-8000-00000000b040',
  AP_F_BASE:     '01926a4c-0000-7000-8000-00000000b041',
  AP_F_CARPO:    '01926a4c-0000-7000-8000-00000000b042',
  AP_F_PINCAS:   '01926a4c-0000-7000-8000-00000000b043',
  AP_PA_MEMBRO:  '01926a4c-0000-7000-8000-00000000b044',
  AP_PA_CARPO:   '01926a4c-0000-7000-8000-00000000b045',
  AP_PA_QUART:   '01926a4c-0000-7000-8000-00000000b046',
  AP_PP_MEMBRO:  '01926a4c-0000-7000-8000-00000000b047',
  AP_PP_JARRETE: '01926a4c-0000-7000-8000-00000000b048',
  AP_PP_QUART:   '01926a4c-0000-7000-8000-00000000b049',
  AP_T_BASE:     '01926a4c-0000-7000-8000-00000000b050',
  AP_T_JARRETES: '01926a4c-0000-7000-8000-00000000b051',
  AP_T_PINCAS:   '01926a4c-0000-7000-8000-00000000b052',
};

const codigoPorId = new Map(Object.entries(TRAIT_CODE_IDS).map(([code, id]) => [id, code]));

/** Id de banco de um codigo de trait. Codigo desconhecido e erro de programacao. */
export function traitCodeId(code: string): string {
  const id = TRAIT_CODE_IDS[code];
  if (!id) throw new Error(`trait sem id fixo: ${code}`);
  return id;
}

/** Codigo de trait a partir do id de banco, ou `undefined` se nao for um id conhecido. */
export function traitCodePorId(id: string): string | undefined {
  return codigoPorId.get(id);
}
